import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Col } from "react-bootstrap";
import PatinetHome from "./PatinetHome";

export default function PatientList() {
    const { t } = useTranslation();
    return (
        <Fragment>
            <Breadcrumbs mainTitle={t("List of Patients")} parent={t("Home")} title={t("List of Patients")} />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <PatinetHome />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
